import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Building2, LayoutGrid, Clock, BellRing, Gavel, HeartPulse, Sparkles, Mail, Users, Database, ChevronRight, X, ClipboardList } from "lucide-react";

export const IMP_CATS = {
  azienda: ["Azienda", "Logo e dati dell'azienda", Building2, "#1f7a5c"],
  pulizie: ["Pulizie", "Mappa degli ambienti e frequenze", Sparkles, "#7c3aed"],
  sistema: ["Sistema e backup", "Backup, database e documenti", Database, "#334155"],
  turni: ["Turni", "Setup orari e regole di copertura", Clock, "#047857"],
  operatori: ["Operatori e solleciti", "Sollecito di inizio turno, avviso fine turno", BellRing, "#b45309"],
  disciplina: ["Disciplina", "Soglie, lettere di richiamo, scadenze", Gavel, "#dc2626"],
  utenti: ["Utenti e permessi", "Ruoli, permessi per sezione, accessi", Users, "#475569"],
  sanitario: ["Area sanitaria", "Impostazioni sanitarie e check-list", HeartPulse, "#be123c"],
  consegne: ["Consegne", "Cosa va in automatico nelle consegne", ClipboardList, "#0f766e"],
  dashboard: ["Dashboard", "Vista predefinita, box per ruolo, Vista Smart", LayoutGrid, "#0369a1"],
  email: ["Email e report", "Email automatiche e report via email", Mail, "#0d9488"],
};
const GRUPPI = [["Struttura e azienda", ["azienda", "pulizie", "sistema"]], ["Personale", ["turni", "operatori", "disciplina", "utenti"]], ["Ospiti e sanitario", ["sanitario", "consegne"]], ["App e comunicazioni", ["dashboard", "email"]]];

// impostazioni che vivono in altre pagine: qui un collegamento diretto
export const IMP_LINK = {
  turni: [["Setup orari dei turni", "Orari di mattina, pomeriggio, notte e cucina per ogni struttura", "/turni?tab=setup"], ["Regole di copertura", "Quanti operatori servono per turno, ore e riposi", "/turni"]],
  pulizie: [["Configurazione mappa", "Ambienti da pulire e frequenze (scegli prima una struttura in alto)", "/pulizie?tab=config"]],
  utenti: [["Utenti, ruoli e permessi", "Chi può entrare e cosa può vedere o modificare", "/utenti"]],
  sistema: [["Backup e database", "Backup automatici ed esportazioni", "/database"]],
  dashboard: [["Vista predefinita, modifica e box per ruolo", "Dalla Dashboard: pulsanti \"predefinita\", \"Modifica dashboard\" e \"Personalizza box per ruolo\"", "/"]],
  sanitario: [["Check-list sanitaria", "Vista predefinita della check-list e voci", "/check-list-sanitaria"]],
  operatori: [["Avviso fine turno", "Tempi modificabili qui sotto, nel riquadro del sollecito", null]],
};

export const ImpLinks = ({ cat }) => {
  const nav = useNavigate();
  const rows = IMP_LINK[cat] || [];
  if (!rows.length) return null;
  return (
    <div className="gr-card divide-y" data-testid={`imp-links-${cat}`}>
      {rows.map(([t, d, path]) => (
        <div key={t} className="flex items-center gap-4 px-5 py-3.5">
          <div className="flex-1 min-w-0"><div className="text-sm font-semibold">{t}</div><div className="text-xs text-muted-foreground">{d}</div></div>
          {path && <button type="button" onClick={() => nav(path)} className="text-sm font-bold text-primary inline-flex items-center gap-0.5 hover:underline" data-testid={`imp-link-${path.replace(/[^a-z]/g, "")}`}>Apri <ChevronRight size={15} /></button>}
        </div>
      ))}
    </div>
  );
};

export const ImpTessere = ({ cat, setCat, pannello }) => {
  useEffect(() => { if (cat) { document.getElementById("imp-pannello")?.scrollIntoView({ behavior: "smooth", block: "nearest" }); } }, [cat]);
  return (
  <div className="space-y-4" data-testid="imp-hub">
    {GRUPPI.map(([g, keys]) => (
      <div key={g}>
        <div className="text-[11px] font-extrabold uppercase tracking-wider text-primary mb-2">{g}</div>
        <div className="rounded-xl border bg-white p-2 flex flex-wrap gap-2">
          {keys.map((k) => { const [l, d, Icon, c] = IMP_CATS[k]; const on = cat === k; return (
            <button key={k} type="button" onClick={() => setCat(on ? null : k)} title={d} className={`rounded-lg px-3 py-2.5 w-[47%] sm:w-[210px] text-left transition-transform hover:-translate-y-0.5 ${on ? "ring-2 ring-offset-1" : ""}`} style={{ background: `${c}14`, "--tw-ring-color": c }} data-testid={`imp-cat-${k}`}>
              <div className="text-[13px] font-bold flex items-center gap-1.5" style={{ color: c }}><Icon size={15} /> {l}</div>
              <div className="text-[11px] text-slate-500 truncate">{d}</div>
            </button>
          ); })}
        </div>
        {keys.includes(cat) && (
          <div id="imp-pannello" className="mt-2 rounded-xl border-2 bg-white/60 p-4 space-y-4 scroll-mt-20" style={{ borderColor: `${IMP_CATS[cat][3]}66` }} data-testid={`imp-pannello-${cat}`}>
            <div className="flex items-center gap-3">
              {React.createElement(IMP_CATS[cat][2], { size: 22, style: { color: IMP_CATS[cat][3] } })}
              <div className="flex-1"><h2 className="font-head font-bold text-xl">{IMP_CATS[cat][0]}</h2><p className="text-xs text-muted-foreground">{IMP_CATS[cat][1]}</p></div>
              <button type="button" onClick={() => setCat(null)} className="w-8 h-8 grid place-items-center rounded-lg border bg-white hover:bg-secondary" title="Chiudi" data-testid="imp-pannello-chiudi"><X size={15} /></button>
            </div>
            {pannello}
          </div>
        )}
      </div>
    ))}
  </div>
  );
};
